
import React, {FC, useEffect, useRef} from 'react';
import classNames from 'classnames';
import {ChatSource} from 'components/Assistant/hooks/types';

import * as styles from './styles.module.scss';

type ChatTextProps = {
	className?: string
	source: ChatSource
	children?: React.ReactNode
	scroll?: boolean
}

export const ChatText: FC<ChatTextProps> = ({
	className, source, children, scroll,
}) => {
	const ref = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (scroll && ref.current) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'start',
			});
		}
	}, [scroll, ref.current]);

	return (
		<div className={classNames({
			[styles.text]: true,
			[styles.assistant]: source === 'ASSISTANT',
			[styles.user]: source === 'USER',
			[className || '']: className,
		})} ref={ref}>
			{children}
		</div>
	);
};
